/* eslint-disable no-restricted-imports */
import { useEffect } from "react";
/* eslint-enable no-restricted-imports */

/**
 * Hook for one-time external synchronization on component mount.
 *
 * Use this hook ONLY for:
 * - DOM integration (focus, scroll)
 * - Third-party widget lifecycles
 * - Browser API subscriptions
 *
 * This is the ONLY approved way to use effects in this codebase.
 * All other effect patterns should be replaced with:
 * - Derived state (compute inline)
 * - Data-fetching libraries (TanStack Query)
 * - Event handlers
 * - Key-based remounting
 *
 * @see https://x.com/alvinsng/status/2033969062834045089
 */
export function useMountEffect(effect: () => void | (() => void)): void {
  // This is the ONLY place in the codebase where useEffect is allowed
  // eslint-disable-next-line react-hooks/exhaustive-deps, no-restricted-syntax
  useEffect(effect, []);
}
